<template>
  <li class="todo" v-bind:class="[{'todo--completed': todo.isDone}, {'todo--editing': todo.isEditing}]">
    <IconCheckbox v-on:click.native="completeTodo(todo)" class="todo__checkbox" :checked="todo.isDone" />
    <div v-on:click="editTodo(todo)" v-if="!todo.isEditing" class="todo__title">{{todo.title}}</div>
    <div v-else class="todo__title-edit-form" >
      <input class="todo__title-edit-input" v-model="todo.title" type="text" v-on:keyup.enter="submitTodo(todo)" />
      <button class="todo__title-edit-button" v-on:click="submitTodo(todo)">Save</button>
    </div>
    <div class="todo__issue-number" v-show="!todo.isEditing"><IconGithub v-show="todo.issueNo.length > 0" class="todo__icon-github"/><span>{{todo.issueNo}}</span></div>
    <IconTrash v-on:click.native="deleteTodo(todo)" v-on-clickaway="cancelDeletion" class="todo__delete" />
    <div class="todo__delete-warning" v-bind:class="[{'todo__delete-warning--active': this.deletionInitialized}]">Are you sure?</div>
  </li>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";

import IconCheckbox from "@/components/icons/IconCheckbox.vue";
import IconGithub from "@/components/icons/IconGithub.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
export default {
  name: "ToDoItem",
  props: ["todo"],
  mixins: [clickaway],
  data() {
    return {
      deletionInitialized: false
    };
  },
  components: { IconCheckbox, IconGithub, IconTrash },
  methods: {
    updateTodoTitle() {},
    editTodo(todo) {
      this.$emit("edit-todo", todo);
    },
    submitTodo(todo) {
      this.$emit("submit-todo", todo);
    },
    completeTodo(todo) {
      this.$emit("complete-todo", todo);
    },
    startDeletion() {
      this.deletionInitialized = true;
    },
    cancelDeletion() {
      this.deletionInitialized = false;
    },
    deleteTodo(todo) {
      if (this.deletionInitialized === true) {
        this.$emit("delete-todo", todo);
      } else {
        this.startDeletion();
      }
    }
  }
};
</script>

<style lang="scss">
.todo {
  position: relative;
  display: grid;
  grid-template-columns: auto auto 1fr auto auto;
  grid-column-gap: 24px;
  align-items: baseline;
  padding: 20px 0;
  cursor: grab;
  background-color: $mono-0;
  &:active {
    cursor: grabbing;
  }
  &:before,
  &:after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 30px;
    width: auto;
    content: "";
  }
  &:before {
    border-bottom: 1px solid $mono-16;
  }
  &:after {
    transition: all 0.3s ease;
    transform: scaleX(0);
    transform-origin: 0 50%;
    border-bottom: 1px solid $mono-100;
  }
  &--editing {
    grid-template-columns: auto 1fr auto auto auto;
    &:after {
      transform: scaleX(1);
    }
  }

  &__checkbox {
    @include icon-size(14px);
    cursor: pointer;
    user-select: none;
    background: $mono-100;
    .todo--completed & {
      background: $mono-33;
    }
  }
  &__title {
    font-size: 20px;
    font-weight: 500;
    cursor: text;
    .todo--completed & {
      font-style: italic;
      text-decoration: line-through;
      color: $mono-33;
    }
  }
  &__title-edit {
    &-form {
      display: grid;
      grid-template-columns: 1fr auto;
      grid-auto-flow: column;
      grid-gap: 20px;
      align-items: center;
    }
    &-input {
      all: unset;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: -5px;
      padding-bottom: 5px;
    }
    &-button {
      all: unset;
      font-size: 12px;
      padding: 2px 5px;
      cursor: pointer;
      letter-spacing: 2px;
      text-transform: uppercase;
      border: 1px solid $mono-100;
      &:hover,
      &:active {
        opacity: 0.8;
      }
    }
  }
  &__issue-number {
    font-size: 14px;
    font-weight: 300;
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 6px;
    align-items: center;
    justify-content: start;
    color: $mono-53;
    .todo--completed & {
      text-decoration: line-through;
      color: $mono-33;
    }
    > span:not(:empty):before {
      content: "#";
    }
  }
  &__icon-github {
    @include icon-size(14px);
    fill: $mono-53;
    .todo--completed & {
      fill: $mono-33;
    }
  }
  &__delete {
    @include icon-size(16px);
    cursor: pointer;
    fill: $mono-16;

    grid-column: -1;
    &:hover {
      fill: $mono-33;
    }
  }
  &__delete-warning {
    font-size: 12px;
    font-weight: 300;
    position: absolute;
    top: 50%;
    right: 25px;
    overflow: hidden;
    width: 0;
    margin-top: -6px;
    transition: all 500ms ease-out;
    text-align: right;
    white-space: nowrap;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: $mono-53;
    &--active {
      width: 150px;
    }
  }
}
</style>
